/* ### CONSTANTS ### */

import { IQueryMetaDataType } from '../../../../../boilerplate/redux/types/IQueryMetaDataType';
import { IApiErrorType } from '../../../../types/BaseTypes';
import { IProductPromotionType } from '../../../Promotion/types/IProductPromotionType';

export const PROMOTION_BOOKMARK_FETCH_ENTRIES = '@BasePipeline/promotionBookmarkReducer_FETCH_ENTRIES';
export const PROMOTION_BOOKMARK_ADD_ENTRIES = '@BasePipeline/promotionBookmarkReducer_ADD_ENTRIES';
export const PROMOTION_BOOKMARK_ADD_ENTRY = '@BasePipeline/promotionBookmarkReducer_ADD_ENTRY';
export const PROMOTION_BOOKMARK_RERENDER = '@BasePipeline/promotionBookmarkReducer_RERENDER';

export const PROMOTION_BOOKMARK_SET_ERRORS   = '@BasePipeline/promotionBookmarkReducer_SET_ERRORS';

/* ### ACTIONS ### */

export function rerenderPromotionBookmarks () {
	return {
		type: PROMOTION_BOOKMARK_RERENDER,
	};
}

export function refetchPromotionBookmarks () {
	return {
		type: PROMOTION_BOOKMARK_FETCH_ENTRIES,
		queryKey: 'promotionBookmarkListing',
		options: {
			forceRefetch: true,
			queryMergeMode: 'replace',
		},
	};
}

export function fetchPromotionBookmarks (queryKey: string) {
	return {
		type: PROMOTION_BOOKMARK_FETCH_ENTRIES,
		queryKey: 'promotionBookmarkListing',
	};
}

export function addPromotionBookmarkEntries (queryKey: string, entries: IProductPromotionType[], metaData?: IQueryMetaDataType , options?: IFetchOptionType) {
	return {
		type: PROMOTION_BOOKMARK_ADD_ENTRIES,
		queryKey,
		entries,
		metaData,
		options
	};
}

export function setPromotionBookmarkErrors (queryKey: string, errors: IApiErrorType[], metaData?: IQueryMetaDataType , options?: IFetchOptionType) {
	return {
		type: PROMOTION_BOOKMARK_SET_ERRORS,
		queryKey,
		errors,
		metaData,
	};
}
